import { makeStyles } from '@mui/styles';

const useAppStyles = makeStyles((theme) => ({
    appContainer: {
        display: 'flex',
        flexDirection: 'column',
    },
    contentWrapper: {
        flex: 1,
        position: 'relative',
    },
    containerRoot: {
        margin: 0,
        padding: 0,
        maxWidth: 'none',
    },
    formContainer: {
        padding: theme.spacing(3),
        marginBottom: theme.spacing(4),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        width: '100%',
    },
    formRow: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        gap: theme.spacing(2),
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    formControl: {
        marginBottom: theme.spacing(1),
        textAlign: 'left',
        width: 220,
        '& .MuiInputLabel-root': {
            backgroundColor: 'white',
            paddingLeft: theme.spacing(0.5),
            paddingRight: theme.spacing(0.5),
        },
    },
    textField: {
        width: 320,
        minWidth: 220,
        marginBottom: theme.spacing(1),
    },
    button: {
        height: 56,
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5),
        marginBottom: theme.spacing(1),
        backgroundColor: '#1976d2',
        fontWeight: 700,
        fontSize: '1rem',
        '&:hover': {
            backgroundColor: '#1565c0',
            boxShadow: '0 4px 12px rgba(25,118,210,0.3)',
        },
    },
    toggleButton: {
        marginBottom: theme.spacing(3),
        marginTop: theme.spacing(2),
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
    },
    promotionCount: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        backgroundColor: '#e3f2fd',
        borderRadius: '4px',
        textAlign: 'center',
        fontWeight: 600,
        color: '#1976d2',
    },
    deleteButton: {
        height: 56,
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(5),
        marginBottom: theme.spacing(1),
        backgroundColor: '#d32f2f',
        fontWeight: 700,
        fontSize: '1rem',
        '&:hover': {
            backgroundColor: '#b71c1c',
            boxShadow: '0 4px 12px rgba(211,47,47,0.3)',
        },
    },
    jsonContainer: {
        marginTop: theme.spacing(3),
        padding: theme.spacing(2),
        backgroundColor: '#ffffff',
        borderRadius: '4px',
        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
    },
}));

export default useAppStyles;

